// ProfileSupport helper functions and data
import { BreadcrumbInfoItem } from "components/global/Breadcrumb/Breadcrumb.types";

export const defaultAddressBreadcrumb: BreadcrumbInfoItem[] = [
  {
    name: "Perfil",
    path: "/profile"
  },
  {
    name: "Legales",
    path: "/profile/legal"
  }
];
